import * as React from "react";
import Accordion from "react-bootstrap/Accordion";
import Button from "react-bootstrap/Button";
import { Link } from "react-router-dom";
import "./routes.css";
import greenReactiveTriadsBodyworkLogo from "../img/greenReactiveTriadsBodyworkLogo.png";

const rtLogo = {
  maxWidth: "220px",
  width: "100%",
  height: "auto",
  borderRadius: "0.5rem",
  marginBottom: "1rem",
};

// Each group renders as its own accordion. Items are {title, body}.
const groups = [
  {
    title: "Our Signature Work",
    defaultOpen: "0",
    items: [
      {
        title: "Reactive Triads™ Bodywork",
        body: (
          <>
            <img
              src={greenReactiveTriadsBodyworkLogo}
              style={rtLogo}
              alt="Reactive Triads Bodywork logo"
            />
            <p>
              Originated and developed by Ann Watkins. Reactive Triads™
              Bodywork brings together the muscle system, the lymphatic system,
              and the joint system. It is truly a breakthrough in chronic pain
              relief and is great for relieving pain in healthy muscles,
              unhealthy muscles, and highly compromised muscles.
            </p>
            <p>
              RT™B uncovers improperly firing muscles by activating three
              elements including the lymphatic system, the joint system, and
              the muscle system. It deactivates compensation patterns in the
              muscles causing pain, achiness, and discomfort. It reprograms the
              body&rsquo;s response to shock, improves lymphatic flow, frees up
              the visceral, decreases swelling, and alleviates muscle pain.
              Reactive Triads™ brings relief to muscle pain, nerve pain,
              limited range of motion, and inflammation and also initiates long
              lasting postural correction. Reactive Triads™, originated in 2001
              (see Ann&rsquo;s DVD, published in 2006-2007, Reactive Triads™ a
              breakthrough in chronic pain) changes the NMR/NKT paradigm from
              pairs to triads and involves more than just the muscle system.
            </p>
            <Link to="/store">
              <Button size="sm">Reactive Triads™ DVD ››</Button>
            </Link>
          </>
        ),
      },
      {
        title: "NeuroMuscular Reprogramming® (NMR) | NeuroKinetic Therapy (NKT)",
        body: (
          <>
            <p>
              Originated by Jocelyn Olivier in the 1970s, NMR is a
              muscle-balancing technique that is super effective on virtually
              healthy bodies. You might also find it called NKT. It uses muscle
              testing to determine if one muscle is inhibiting another muscle
              from firing. It uncovers muscles that are working too hard and
              muscles that are not working hard enough. With retest it gets the
              underworking muscles reconnected to the brain and allows the
              overworking muscles to relax. The result is an increased range of
              motion and decreased pain and a building of support in virtually
              healthy muscles. Other intervention is needed for unhealthy or
              very compromised muscles. See Reactive Triads™ Bodywork.
            </p>
            <p>
              Muscles need to be able to contract and relax as needed whether
              they are working isometrically or in complement to one another.
              With this muscle balancing technique, the muscles learn to
              appropriately activate and deactivate; pain is relieved, posture
              improves, range of motion increases, and the ability to relax is
              enhanced. This often takes more than one session.
            </p>
          </>
        ),
      },
      {
        title: "Postural Corrective Bodywork",
        body: (
          <p>
            Integrates our original education with our continuing education
            and our original work.
          </p>
        ),
      },
      {
        title: "Somatic Integration with Reactive Triads™",
        body: (
          <p>
            Somatic Integration in our bodywork is based on the assumption that
            our muscles carry past memories or beliefs about ourselves. When
            deep-seated muscle tension is released, muscle memories or beliefs
            about ourselves can surface in association with the chronic pain or
            tension we are working to resolve. For complete healing to occur,
            rather than entertain story or judgement associated with it, what
            seems to work best is to feel into the tension and let it dissolve,
            integrate and, if pertinent, choose to maintain or change whatever
            belief we've been carrying. Through pain relief and postural
            correction, what we've sequestered in our muscles from old traumas
            may surface, but resolve with corrective techniques which integrate
            into new awareness, new understandings and a more comfortable
            in-your-body experience. Occasionally, a "healing crisis" might
            occur: a flooding of old issues and associated physical pain for a
            limited time as your body integrates the plethora of new
            information and insights. It might be important to be aware of
            your balance if your body needs more time than the session to get
            used to the new muscle patterns being introduced and to integrate
            the somatic information.
          </p>
        ),
      },
      {
        title: "Spinal Postural Stabilization",
        body: (
          <p>
            We may give you exercises that increase strength, mobility,
            endurance, coordination, and balance. As the stabilization of your
            back increases, movement without pain is supported and your pain is
            much more likely to &ldquo;just go away&rdquo;.
          </p>
        ),
      },
    ],
  },
  {
    title: "Massage & Relaxation",
    items: [
      {
        title: "Relaxation Massage",
        body: (
          <p>
            Relaxation Massage is greatly enhanced by the integration of
            Reactive Triads™ Bodywork as it teaches the muscles how to relax.
            When relaxation is specified we will typically use more Swedish,
            Pressure point (acupressure, shiatsu), and other more typically
            familiar forms of massage. If we find a muscle area that is not
            responding to other more typical modalities we will ask you if you
            mind if we do some testing. If you specifically do not want the
            testing to be included we will honor that request. Typically
            muscles relax more deeply with muscle balancing where other
            modalities don&rsquo;t do the trick.
          </p>
        ),
      },
      {
        title: "Swedish Massage",
        body: (
          <p>
            One of the most common forms of massage, Swedish relaxes the
            muscles and eases aches and pains. It is always integrated into our
            form of bodywork which specializes in postural correction and pain
            relief.
          </p>
        ),
      },
      {
        title: "Deep Tissue",
        body: (
          <p>
            A technique that works slowly and deeply through the layers of
            muscle and fascia, it lengthens tight or shortened muscles,
            stretches scar tissue and releases adhesions that have resulted
            from trauma, injury, operations, or repetitive strain. This work
            helps to improve posture, range of motion, function, and strength
            and is typically integrated into our sessions.
          </p>
        ),
      },
      {
        title: "Sports Massage",
        body: (
          <p>
            Developed specifically to treat the athlete, sports massage
            techniques are utilized at all stages of an event: pre-event to
            bring health and wellness to the tissues; post-event to enhance
            recovery; during training to maintain the muscles and enable peak
            performance and, at any appropriate point, to expedite
            rehabilitation after injury. Our practitioners may utilize sports
            massage techniques to facilitate results during a session.
          </p>
        ),
      },
      {
        title: "Deep Relaxation / The Zone",
        body: (
          <p>
            We have often had people fall asleep on the table or enter into the
            realm of the Zone: entering a place of deep relaxation but being
            cognizant at the same time, like a daytime dream state. It is a
            place of deep integration yet there remains the ability to follow
            directions as needed with the muscle balancing work that we do.
            This is an amazing place to be in and is exceptionally healing.
          </p>
        ),
      },
    ],
  },
  {
    title: "Lymphatic, Visceral & Energy Work",
    items: [
      {
        title: "Lymphatic Drainage",
        body: (
          <p>
            This is a technique used to reduce inflammation in the interstitial
            tissues. The lymphatic system cleanses a third of your blood at a
            time. It transports molecules too large for the circulatory system
            to places in the body in need of healing. In the case of toxins it
            transports to the excretory system. Mostly a light touch technique,
            because most lymph fluid is located just under the skin, it
            increases the volume that circulates through the body by about
            20x. Bruno Chikly&rsquo;s method of lymphatic drainage was
            originally developed to deal with lymphedema after cancer surgery.
            Ann Watkins has worked with pre and post cancer patients in
            relieving lymphedema and uses it for general health in many of her
            clients as needed. Reactive Triads™ incorporates lymphatic drainage
            into its method in order to speed the process of reducing
            inflammation with the action of the muscles (see the{" "}
            <Link to="/store">Reactive Triads™ DVD</Link>). This is especially
            important if you have Fibromyalgia or other chronic inflammation;
            migraines are often accompanied by chronic, residual inflammation.
            You will be less sore or no longer sore.
          </p>
        ),
      },
      {
        title: "Visceral Manipulation",
        body: (
          <p>
            Visceral Manipulation is a very gentle technique developed by
            Jean-Pierre Barral. We listen to the tissues, the internal organs,
            as well as other body structures so they can track more properly
            and freely. Our bodies are meant to move and accommodate from the
            inside out. When tissues get sticky due to illness, accidents,
            injury the tissues can stop sliding over one another the way that
            they are meant to and the internal organs become limited in their
            intended movement. We hold the tissue in the direction of ease or
            intention so that the body can make an appropriate shift and free
            up tissue to move as it was meant to. Great for your health and
            well being and helpful for many maladies. Combined as needed with
            Reactive Triads™ Bodywork.
          </p>
        ),
      },
      {
        title: "Energy Work",
        body: (
          <p>
            Energy work may include Acupressure, Shiatsu, Brain Gym, Energy
            Balancing, work with chakras/Reiki, or organ massage as done in
            Lymphatic Drainage, and is typically integrated into the whole
            massage as needed. Although we may do a full session if requested
            with one of these modalities, we do not specialize in them and, if
            that is what you are specifically interested in, you may want to
            consider going to a practitioner that does. Our clients rarely find
            a single modality to be more effective than our integrated
            approach.
          </p>
        ),
      },
      {
        title: "Acupressure",
        body: (
          <p>
            Granddaughter to Shiatsu, Acu means finger. In Acupressure two
            points are held until they begin to pulse consistently and strongly
            together. This tunes up your energy body system and relieves pain
            and discomfort. Unlike Shiatsu, it doesn&rsquo;t necessarily follow
            a meridian. In fact, it tends to cross meridians, characterized by
            &ldquo;strange flows&rdquo;. Can be very effective in relieving
            chronic problems involving an energy component. May be
            incorporated into a session. We do not specialize in this and
            encourage you to seek elsewhere if this is what you are
            specifically interested in.
          </p>
        ),
      },
      {
        title: "Shiatsu",
        body: (
          <p>
            Another way to say finger pressure, Shiatsu has a long history in
            the Orient. Using various digits, the practitioner follows the
            body&rsquo;s meridians (the physical lines of the energetic body)
            using thumbs frequently or fingers as needed. Like Acupressure it
            tunes up the energy system and can be used at various depths to
            the muscle to create a strong pressure, a medium pressure, or a
            light pressure depending on what your body calls for. Older people
            especially find it to be very grounding and centering when other
            bodywork leaves them feeling disoriented. May be incorporated into
            a session and occasionally may comprise the bulk of a session but
            it is not what we specialize in and we therefore encourage you to
            seek elsewhere if this is what you are specifically interested in.
          </p>
        ),
      },
      {
        title: "Polarity",
        body: (
          <p>
            Polarity is also an energy work that uses finger pressure.
            Essentially, it locates two correspondingly sore points on the body
            and uses alternate circular motion to relieve the knots and muscle
            discomfort. This is the part of polarity we tend to incorporate
            into our sessions. It is a much more extensive practice than just
            that but it is not something we specialize in. We encourage you to
            look elsewhere if that is what you are specifically interested in.
          </p>
        ),
      },
    ],
  },
  {
    title: "Special Populations",
    items: [
      {
        title: "Teens and Children",
        body: (
          <p>
            When working with teens and children, the sessions are usually
            shorter and the kids wear a bathing suit or shorts and an
            undershirt or something similar. It tends to take fewer sessions
            because even if the problem is systemic it is not deeply ingrained.
            This does not necessarily apply if there are mitigating problems,
            like CP or MS or other such problems, although Reactive Triads™
            Bodywork can be correctional for scoliosis and is very helpful in
            the cases of Cerebral Palsy and Multiple Sclerosis. Parents may
            stay in the room.
          </p>
        ),
      },
    ],
  },
];

function Therapies() {
  return (
    <div className="pageBg">
      <div className="container">
        <div className="pageCard">
          <h2 className="pageTitle">Therapies We Offer</h2>

          <p className="pageLead">
            Our therapies offer a breakthrough in chronic pain relief through
            years of professional education and practice.
          </p>

          <p>
            <strong>
              We have studied many therapies over the years and have integrated
              into our repertoires what we've found to be most useful from
              each.
            </strong>{" "}
            We specialize in Reactive Triads™ Bodywork, a postural corrective
            muscle balancing technique originated by Ann Watkins. It is based
            in NeuroMuscular Reprogramming (NMR), originated by Jocelyn Olivier
            in the &rsquo;70s, and solves problems that were unsolvable using
            NMR alone.
          </p>
          <p>
            Additional therapies are integrated into any given session as
            needed. If you are only looking for a particular therapy listed
            below you may want to contact a practitioner who specializes in it
            alone; however, our clients have most often found our eclectic
            blend to be more effective than one specific modality.
          </p>

          {groups.map((group) => (
            <React.Fragment key={group.title}>
              <h3 className="sectionTitle">{group.title}</h3>
              <Accordion
                className="therapyAccordion"
                defaultActiveKey={group.defaultOpen}
              >
                {group.items.map((item, i) => (
                  <Accordion.Item eventKey={String(i)} key={item.title}>
                    <Accordion.Header>{item.title}</Accordion.Header>
                    <Accordion.Body>{item.body}</Accordion.Body>
                  </Accordion.Item>
                ))}
              </Accordion>
            </React.Fragment>
          ))}

          <h3 className="sectionTitle">Classes &amp; Conscious Anatomy™</h3>
          <p>
            Conscious Anatomy™ foundation courses teach anatomy through
            movement with somatic awareness and energetic attunement, with
            advanced courses in Reactive Triads™ Bodywork. New offerings every
            Fall. Movement for Body Mind and Spirit™ is not currently offered
            but may return in the future.
          </p>
          <div style={{ display: "flex", flexWrap: "wrap", gap: "0.5rem" }}>
            <Link to="/classes">
              <Button>Class Listings ››</Button>
            </Link>
            <a
              href="https://www.bodymindspiritanatomy.com/"
              target="_blank"
              rel="noreferrer"
            >
              <Button variant="outline-primary">
                Conscious Anatomy™ Courses &amp; Freebies ››
              </Button>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
export default Therapies;
